// Generated by ReScript, PLEASE EDIT WITH CARE

import * as PartnerContentHelper from "./PartnerContentHelper.bs.js";

function getContent(message_text, vehicle_category, geo_region) {
  vehicle_category !== 0;
  return {
          title_text: "கேன்சலேஷன் ஸ்கோர்",
          learn_more_text: "மேலும் அறிந்துகொள்ள",
          info_btn_details: {
            video_url: undefined,
            question: "கேன்சலேஷன் ஸ்கோர் எப்படி கணக்கிடப்படுகிறது?",
            answer: "நீங்கள் கடைசியாக ஏற்றுக்கொண்ட 30 ஆர்டர்களில் டிரைவருக்குக் கூறப்படும் மொத்த கேன்சலேஷன்-களின் அடிப்படையில் கேன்சலேஷன் ஸ்கோர் கணக்கிடப்படுகிறது."
          },
          learn_more_btn_details: [
            {
              video_url: PartnerContentHelper.getV2LearnMoreVid(geo_region),
              question: "கேன்சலேஷன் ஸ்கோர் என்றால் என்ன மற்றும் அது ஏன் முக்கியமானது?",
              answer: ""
            },
            {
              video_url: undefined,
              question: "நான் எப்போது இடைநீக்கம் செய்யப்படுவேன்?",
              answer: "நீங்கள் குறிப்பிட்ட அளவைக் கடக்கும் போதெல்லாம், நீங்கள் அதற்கு ஏற்ப சில  காலத்திற்கு இடைநீக்கம் செய்யப்படுவீர்கள்."
            },
            {
              video_url: undefined,
              question: "ஒவ்வொரு நிலைகளுக்கும் இடைநீக்க கால அளவு என்ன?",
              answer: "ஒவ்வொரு நிலைகளுக்கும் இடைநீக்கத்தின் கால அளவை இடைநீக்க வழிகாட்டியில் சரிபார்க்கலாம்."
            },
            {
              video_url: undefined,
              question: "கேன்சலேஷன் ஸ்கோரை என்னால் ஏன் பார்க்க முடியவில்லை?",
              answer: "சமீபத்திய மாதங்களில் குறைந்தபட்சம் 30 ஆர்டர்கள் ஏற்றுக்கொள்ளப்பட்ட ஓட்டுனர்களுக்கு மட்டும் கேன்சலேஷன் ஸ்கோர் கணக்கிடப்படுகிறது."
            }
          ],
          locked_score_msg: "கேன்சலேஷன் ஸ்கோரை காண அதிக ஆர்டர்களை ஏற்கவும்.",
          message_text: message_text,
          suspension_guide_text: "இடைநீக்கம் தொடர்பான வழிகாட்டி",
          suspension_guide_table_details: {
            cancellation_score_text: "கேன்சலேஷன் ஸ்கோர்",
            suspension_days_text: "இடைநீக்க நாட்கள்"
          }
        };
}

export {
  getContent ,
  
}
/* No side effect */
